import * as React from 'react';
import { DSConfirmDialogProps, DSConfirmDialog } from '../../../mui';
import { DSButtonProps, DSButton } from '../DSButton';

export type DSConfirmButtonProps = Omit<DSButtonProps, 'onClick'> &
    Pick<
        DSConfirmDialogProps,
        'cancelText' | 'confirmationText' | 'confirmColor' | 'confirmText' | 'dialogTitle' | 'message'
    > & {
        /**
         * Action handler for confirm button in the modal
         */
        onConfirm: () => void;
        /**
         * The title of the modal
         *
         * @default 'Are you sure?'
         */
        title?: string;
        dialogConfirmDisabled?: boolean;
    };

export const DSConfirmButton: React.FunctionComponent<DSConfirmButtonProps> = ({
    cancelText,
    children,
    confirmationText,
    confirmColor,
    confirmText,
    dialogConfirmDisabled,
    dialogTitle = 'Are you sure?',
    disabled,
    message,
    onConfirm,
    ...remainingProps
}) => {
    const [isShowingModal, showModal] = React.useState(false);

    return (
        <>
            <DSButton disabled={disabled} onClick={() => showModal(true)} {...remainingProps}>
                {children}
            </DSButton>
            <DSConfirmDialog
                cancelText={cancelText}
                confirmColor={confirmColor}
                confirmText={confirmText}
                confirmationText={confirmationText}
                dialogConfirmDisabled={dialogConfirmDisabled}
                dialogTitle={dialogTitle}
                message={message}
                open={isShowingModal}
                onClose={() => showModal(false)}
                onConfirm={onConfirm}
            />
        </>
    );
};
DSConfirmButton.displayName = 'DSConfirmButton';
